import { createTypes } from 'reduxsauce'
 
export default createTypes(`
GET_BANK_VERIFICATION_INITIAL_DATA
`, {}) // options - the 2nd parameter is optional